import { QFilterGeneric } from './QFilterGeneric'

export class QFilterDates extends QFilterGeneric {
  name = "filter_dates";
  class_name = "QFilterDates";
  api_name = 'filter_dates';

  serialize(qfilters) {
    return encodeURIComponent(JSON.stringify(this.value));
  }
}
